import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../../styles/AdminStyles.css';

const Dashboard = () => {
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/admin/login');
  };

  return (
    <div className="admin-wrapper">
      <div className="admin-header">
        <h1 className="admin-title">Панель управления</h1>
        <button onClick={handleLogout} className="admin-logout-btn">Выйти</button>
      </div>
      <div className="admin-nav">
        <Link to="/admin/news" className="admin-nav-link">📰 Новости</Link>
        <Link to="/admin/candidates" className="admin-nav-link">👥 Кандидаты</Link>
        <Link to="/admin/gallery" className="admin-nav-link">🖼️ Галерея</Link>
        <Link to="/admin/pages" className="admin-nav-link">Управление страницами</Link>
        <Link to="/admin/documents">📄 Управление документами</Link>
      </div>
      <div className="admin-card">
        <div className="admin-card-header">Добро пожаловать!</div>
        <p>Выберите раздел для управления контентом сайта.</p>
      </div>
    </div>
  );
};

export default Dashboard;